export default __webpack_public_path__ + "static/media/video-poster-2-2@2x.c99e2d04.png";